import { Callout } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { CompanyInvoices } from './components/CompanyInvoices';
import { CompanyPlanSubscriptionContainer } from './components/CompanyPlanSubscription';
import { LegacyCompanyPlanSubscription } from './components/LegacyCompanyPlanSubscription';
import {
  type CompanySubscription,
  type Invoice,
  isChargebeeSubscription,
} from '../../models';

type Props = {
  companySubscription: CompanySubscription | undefined;
  invoices: Invoice[];
  hasNextPage: boolean;
  fetchNextPage: () => void;
};

export const CompanyPlan = ({
  companySubscription,
  invoices,
  hasNextPage,
  fetchNextPage,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <>
      {companySubscription ? (
        <>
          {isChargebeeSubscription(companySubscription) ? (
            <CompanyPlanSubscriptionContainer
              companySubscription={companySubscription}
            />
          ) : (
            <LegacyCompanyPlanSubscription
              companySubscription={companySubscription}
            />
          )}
        </>
      ) : (
        <Callout
          className="mt-16"
          title={t('billing.subscriptionLoadError')}
          variant="warning"
        />
      )}
      {invoices.length > 0 && (
        <CompanyInvoices
          invoices={invoices}
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
        />
      )}
    </>
  );
};
